export default __webpack_public_path__ + "static/media/home_content_5.597a3dec.png";